var map = {
	"./SpaceDetails.vue": "yX+n",
	"./SpaceLifeAlbum.vue": "AMPC",
	"./SpacePhoto.vue": "03PH",
	"./SpaceTab.vue": "/0nn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EBIa";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PartII/SpaceDetails/components nonrecursive \.vue$
// module id = EBIa
// module chunks = 1